import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Expertise } from "@/components/Expertise";
import { About } from "@/components/About";
import { Leadership } from "@/components/Leadership";
import { Business } from "@/components/Business";
import { CultureEthics } from "@/components/CultureEthics";
import { Partners } from "@/components/Partners";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Expertise />
        <About />
        <Leadership />
        <Business />
        <CultureEthics />
        <Partners />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-right" theme="light" />
    </div>
  );
}

export default App;
